import { combineReducers } from 'redux';
import navbarReducer from './redux';
import userSettingsReducer from '../../../modules/user/profile/redux';

export default combineReducers({
  navbar: navbarReducer,
  userSettings: userSettingsReducer
});
